import { CvExportsButton } from "PFApp/components/cv_exports_button";
import { Icon } from "PFComponents/icon";
import { Tabs } from "PFComponents/tabs";
import { useRoleName } from "PFCore/helpers/activities";
import { Activity } from "PFTypes";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router";

import { ComparableProfile } from "../details/parts/use_cell_data";
import css from "./compare_header.module.scss";

type CompareHeaderProps = {
  activity: Activity;
  tabActiveId: "details" | "availability";
  changeTab: (tab: string) => void;
  comparableProfiles: ComparableProfile[];
};

export const CompareHeader = ({
  activity,
  tabActiveId,
  changeTab,
  comparableProfiles
}: CompareHeaderProps) => {
  const { t } = useTranslation("activities");
  const { t: tTranslation } = useTranslation();
  const getRoleName = useRoleName();
  const location = useLocation();
  const TABS = [
    { id: "details", title: t("compare.compareDetails") },
    { id: "availability", title: t("compare.compareAvailabity") }
  ];

  const prevPath = useRef(location.state?.prevPath);
  return (
    <div className={css.root}>
      <div className={css.header}>
        <Link className={css.back} to={prevPath.current || `/activities/${activity.id}/shortlist`}>
          <Icon name="chevron-left" size="xxs" />
          {t("compare.exitCompare")}
        </Link>
        <CvExportsButton
          profileIds={comparableProfiles.map(({ profile }) => profile.id)}
          activityId={activity.id}
          text={tTranslation("exportText")}
          icon={undefined}
          kind="primary"
        />
      </div>

      <div className={css.row}>
        <div className={css.tabs}>
          <Tabs onChange={changeTab} tabs={TABS} activeTab={tabActiveId} />
        </div>
        {activity && activity.name && <h1 className={css.name}>{getRoleName(activity)}</h1>}
      </div>
    </div>
  );
};
